// Copyright (c) 2019 Deere & Company

import { getDefaultState as getLocationDefaultState } from './location';
import t from 'tcomb';

const Dealer = t.struct({
    account: t.maybe(t.String),
    currency: t.maybe(t.String),
    division: t.maybe(t.String),
    email: t.maybe(t.String),
    industryIndicator: t.maybe(t.String),
    leadAccount: t.maybe(t.String),
    location: t.Object,
    name: t.maybe(t.String),
    phone: t.maybe(t.String),
}, {
    name: 'Dealer',
    strict: false,
});

export const getDefaultState = () => new Dealer({
    account: '',
    currency: '',
    division: '',
    email: '',
    industryIndicator: '',
    leadAccount: '',
    location: getLocationDefaultState(),
    name: '',
    phone: '',
});

export default Dealer;
